// =============================================================
// 🎟️ QueueSizeCard.jsx — Tamanho da fila
// =============================================================

import React from "react";

export default function QueueSizeCard({ value }) {
  const fila = typeof value === "number" ? value : 0;

  const getBadgeStatus = () => {
    if (fila === 0) return "ok";
    if (fila <= 3) return "warn";
    return "alert";
  };

  const badge = getBadgeStatus();

  return (
    <div className="ia-kpi-card">
      <div className="ia-kpi-card-header">
        <span className="ia-kpi-label">Fila de espera</span>
        <span className="ia-kpi-icon">
          <i className="fas fa-list-ol" />
        </span>
      </div>

      <div className="ia-kpi-main-value">
        {fila} sessão{fila === 1 ? "" : "s"}
      </div>

      <div className="ia-kpi-sub">
        <span
          className={`ia-queue-badge ia-queue-badge-${badge}`}
        >
          {badge === "ok" && "Fluxo tranquilo 💗"}
          {badge === "warn" && "Atenção à fila ⏳"}
          {badge === "alert" && "Fila alta, priorizar atendimentos 🔥"}
        </span>
      </div>
    </div>
  );
}
